const Chart =
  typeof window !== 'undefined'
    ? require('react-apexcharts').default
    : () => null;

const labels = [
  'Integrated Rural Community Aging Program',
  'Children, Youth and Families (Includes YIP)',
  'Individual and Community Wellbeing',
  'Covid Response',
  `Maada'ookiing`,
  'Other',
];
const series = [1598000, 439098, 741600, 4647086, 32300, 74840];
const numberOfGrants = [26, 52, 42, 501, 13, 10];
const colors = [
  '#9ECE3F',
  '#8ABB2A',
  '#639500',
  '#3C7100',
  '#194E00',
  '#112D00',
];

const options = {
  labels,
  dataLabels: {
    style: {
      fontSize: '12px',
      fontFamily: 'Montserrat',
      fontWeight: '700',
      colors: ['#fff'],
    },
    formatter(_, options) {
      const value = series[options.seriesIndex];

      return [null, '$' + value.toLocaleString('en-US').replace(/\..*/, '')];
    },
  },
  colors,
  legend: {
    position: 'right',
    fontSize: '16px',
    fontWeight: '700',
    fontFamily: 'Montserrat',
    formatter(value, options) {
      return [
        `${value}<br />
         ${numberOfGrants[options.seriesIndex]} grants –
         <span>$${series[options.seriesIndex]
           .toLocaleString('en-US')
           .replace(/\..*/, '')}</span>`,
      ];
    },
    onItemClick: {
      toggleDataSeries: false,
    },
    onItemHover: {
      highlightDataSeries: true,
    },
  },
  tooltip: {
    fillSeriesColor: true,

    y: {
      formatter(value, options) {
        return '$' + value.toLocaleString('en-US').replace(/\..*/, '');
      },
    },
  },
  plotOptions: {
    pie: {
      donut: {
        size: '60%',
        labels: {
          show: true,
          value: {
            fontSize: '24px',
            fontFamily: 'Montserrat',
          },
          total: {
            show: true,
            showAlways: true,
            label: 'TOTAL',
            fontSize: '28px',
            fontFamily: 'Kapra Neue',
            formatter(w) {
              return (
                '$' +
                w.globals.seriesTotals
                  .reduce((a, b) => a + b, 0)
                  .toLocaleString('en-US')
                  .replace(/\..*/, '')
              );
            },
          },
        },
      },
    },
  },
  responsive: [
    {
      breakpoint: 800,
      options: {
        chart: {
          width: '100%',
        },
        legend: {
          position: 'bottom',
        },
      },
    },
  ],
};

export const PieChart = () => {
  return (
    <div style={{ margin: '24px 0 48px' }}>
      <Chart
        options={options}
        series={series}
        type="donut"
        width="100%"
        height="500"
      />
    </div>
  );
};

// IRCAP
// $1,598,000
// 26

// CHILDREN, YOUTH AND FAMILIES (INCLUDES YIP)
// $439,098
// 52

// INDIVIDUAL AND COMMUNITY WELLBEING
// $741,600
// 42

// COVID REPONSE
// (381 SBRG, 53 Child Care, 63 GEERs, 4 Targeted)
// $4,647,086
// 501

// MAADA'OOKIING
// $32,300
// 13

// OTHER
// $74,840
// 10

// TOTAL
// $7,532,924
// 644
